import { render } from "./accordions.vue?vue&type=template&id=2e2c9a1f"
import script from "./accordions.vue?vue&type=script&lang=js"
export * from "./accordions.vue?vue&type=script&lang=js"

import exportComponent from "/Users/brunocarvalho/Projetos/admin-colegio-encanto-juvenil/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__